import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { BaseDialog } from '@library-shared/base/base-dialog.component';
import { EventBusService } from '@library-shared/services/event-bus/event-bus.service';
import { spTicket_List } from '@models/StoredProcs/spTicket_List';
import { DxTextBoxComponent } from 'devextreme-angular';
import {
  extMail_Out_Document_Validate_Pin_Request,
  PleaService,
} from '@services/plea/plea.service';

@Component({
  selector: 'app-plead-dialog',
  templateUrl: './plead-dialog.component.html',
  styleUrls: ['./plead-dialog.component.scss'],
  standalone: false,
})
export class PleadDialogComponent extends BaseDialog implements OnInit {
  @ViewChild('edtLetterCode') edtLetterCode: DxTextBoxComponent;
  @Output() completed = new EventEmitter<boolean>();
  title = 'Must Appear Ticket Options';
  ticket: spTicket_List;

  options = [
    { name: 'Plea by Mail', value: 'PBM' },
    { name: 'Video Conference', value: 'VC' },
  ];

  option_selected = 'PBM';
  letter_code = '';
  pin = '';

  constructor(
    public eventBusService: EventBusService,
    private pleaService: PleaService
  ) {
    super(eventBusService);
  }

  onShown() {
    setTimeout(() => {
      this.edtLetterCode?.instance?.focus();
    }, 100);
  }

  ngOnInit(): void {}

  showDialog(rec: spTicket_List) {
    this.ticket = rec;
    this.option_selected = 'PBM';
    this.letter_code = '';
    this.pin = '';
    this.showDialogBase();
  }

  onSubmit(e: any): void {
    if (this.option_selected !== 'PBM') {
      this.completed.emit(true);
      this.closeDialogBase();
      return;
    }

    if (!this.letter_code?.trim() || !this.pin?.trim()) {
      this.toast_warn({ message: 'Letter code and PIN are required.' });
      return;
    }

    this.isLoading2.set(true);

    const req = new extMail_Out_Document_Validate_Pin_Request({
      mail_out_document_number: this.letter_code.trim(),
      pin: this.pin.trim(),
    });

    this.pleaService.Mail_Out_Document_Validate_Pin(req).subscribe({
      next: (resp) => {
        this.isLoading2.set(false);

        if (!resp?.success) {
          this.toast_error({ message: resp?.message || 'Validation failed.' });
          return;
        }

        if (!resp.records || resp.records.length === 0) {
          this.toast_warn({ message: 'Invalid letter code / PIN combination.' });
          return;
        }

        this.completed.emit(true);
        this.closeDialogBase();
      },
      error: () => {
        this.isLoading2.set(false);
      },
    });
  }

  onCancel(e: any): void {
    this.completed.emit(false);
    this.closeDialogBase();
  }
}
